{
  "user": {
    "form": {
      "addTitle": "建立使用者",
      "editTitle": "編輯使用者",
      "fields": {
        "username": "使用者名稱",
        "email": "電子郵件",
        "fullName": "姓名",
        "password": "密碼",
        "confirmPassword": "確認密碼",
        "facility": "機構",
        "roles": "角色",
        "active": "啟用",
        "allFacilities": "所有機構（全醫療系統）",
        "globalAccessAck": "我了解此設定將授予存取所有機構的權限",
        "departments": "科室",
        "primaryDepartment": "主科室",
        "roleFacility": "{{role}} 的機構",
        "grantEffective": "Effective date for {{role}} (blank = today)",
        "grantExpiration": "Expiration date for {{role}} (blank = permanent)",
        "grantProvenance": "Granted by {{name}}",
        "grantProvenanceDate": "Granted by {{name}} · {{date}}",
        "addFacilityToRole": "+ 新增機構",
        "removeFacilityFromRole": "移除一個",
        "otherRoles": "其他"
      },
      "errors": {
        "usernameMin": "使用者名稱至少需要 {{min}} 個字元",
        "emailInvalid": "電子郵件格式無效",
        "passwordMin": "密碼至少需要 {{min}} 個字元",
        "confirmPasswordRequired": "請確認密碼",
        "passwordMismatch": "兩次輸入的密碼不一致",
        "rolesRequired": "至少需要選擇一個角色",
        "grantPeriodInvalid": "The grant ends before it starts",
        "globalAccessAckRequired": "儲存前請確認全醫療系統授權。"
      },
      "submit": {
        "create": "建立使用者",
        "update": "更新使用者"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "使用者建立成功",
        "updatedSuccess": "使用者更新成功",
        "saveError": "儲存使用者失敗",
        "departmentsSaveError": "使用者已儲存，但科室指派失敗。請編輯該使用者重試。"
      },
      "globalAccessWarning": "此設定將授予存取「每一家」機構病人的權限，而不僅是呼叫範圍。請僅用於真正涵蓋全醫療系統的人員，例如值班人員。",
      "departmentsHint": "該帳戶的工作科室。僅用於記錄歸屬，不授予任何病人存取權限。",
      "noDepartments": "尚未設定任何科室。"
    },
    "list": {
      "title": "使用者管理",
      "subtitle": "管理系統使用者、角色及存取權限",
      "columns": {
        "username": "使用者名稱",
        "fullName": "全名",
        "email": "電子郵件",
        "roles": "角色",
        "facility": "機構",
        "status": "狀態",
        "lastLogin": "上次登入",
        "actions": "操作",
        "signIn": "Sign-in"
      },
      "filter": {
        "search": "搜尋使用者...",
        "allRoles": "所有角色",
        "allFacilities": "所有機構",
        "allStatus": "所有狀態",
        "active": "啟用",
        "inactive": "停用"
      },
      "actions": {
        "new": "建立使用者",
        "editTitle": "編輯使用者",
        "resetPasswordTitle": "重設密碼",
        "activate": "啟用",
        "deactivate": "停用",
        "activateAria": "啟用使用者",
        "deactivateAria": "停用使用者"
      },
      "lastLoginNever": "從未",
      "empty": "找不到符合篩選條件的使用者",
      "pagination": {
        "summary": "顯示 {{from}}-{{to}}，共 {{total}} 項"
      },
      "toast": {
        "activated": "使用者 {{username}} 已啟用",
        "deactivated": "使用者 {{username}} 已停用",
        "passwordHasBeenReset": "Password for {{username}} has been reset",
        "statusFailed": "Could not update the status of {{username}}",
        "passwordFailed": "Could not reset the password"
      },
      "allFacilities": "所有機構",
      "deactivateConfirm": {
        "title": "Deactivate {{username}}?",
        "description": "New logins and token refreshes for {{username}} will be refused. Their roles are kept, so reactivating restores access.",
        "confirm": "Deactivate"
      },
      "resetPassword": {
        "title": "Reset password for {{username}}",
        "description": "Set a new password. It must be at least 12 characters with upper- and lowercase letters, a digit and a special character.",
        "label": "New password",
        "confirm": "Reset password"
      },
      "signIn": {
        "local": "Local",
        "sso": "SSO",
        "ldap": "Directory"
      }
    },
    "status": {
      "active": "啟用",
      "inactive": "停用",
      "locked": "已鎖定",
      "pendingActivation": "待啟用"
    },
    "mfaStatus": {
      "enrolled": "已註冊",
      "notEnrolled": "未註冊",
      "exempt": "豁免"
    }
  },
  "role": {
    "form": {
      "addTitle": "建立角色",
      "editTitle": "編輯角色",
      "fields": {
        "name": "角色名稱",
        "code": "角色代碼",
        "description": "描述",
        "category": "分類",
        "parentRole": "父角色（繼承權限）"
      },
      "options": {
        "none": "無"
      },
      "errors": {
        "nameRequired": "請輸入角色名稱",
        "codeRequired": "請輸入角色代碼"
      },
      "submit": {
        "create": "建立角色",
        "update": "更新角色"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "角色建立成功",
        "updatedSuccess": "角色更新成功",
        "saveError": "儲存角色失敗"
      }
    },
    
    "status": {
      "active": "啟用",
      "inactive": "停用"
    },
    "source": {
      "own": "自身",
      "inherited": "繼承",
      "category": "分類"
    },
    "permissions": {
      "ownTitle": "編輯權限",
      "deniedTitle": "編輯拒絕權限",
      "ownSubtitle": "已授予 {{granted}}/{{total}}。繼承及分類預設權限顯示在存取矩陣中；本頁面僅管理此角色本身的授權。",
      "deniedSubtitle": "拒絕權限會覆蓋角色本身、父角色及分類預設的所有授權。勾選權限即明確為此角色拒絕該權限。",
      "invalidRoleId": "角色 ID 無效。",
      "save": "儲存權限",
      "saveDenied": "儲存拒絕權限",
      "cancel": "取消",
      "toast": {
        "updatedSuccess": "權限已更新",
        "deniedUpdatedSuccess": "拒絕權限已更新",
        "saveError": "儲存權限失敗",
        "saveDeniedError": "儲存拒絕權限失敗"
      },
      "permissionGroup": {
        "analytics": "分析",
        "audit": "稽核",
        "billing": "計費",
        "bloodProduct": "血液製品",
        "consent": "知情同意",
        "dietOrder": "飲食醫囑",
        "discharge": "出院",
        "documentation": "記錄",
        "encounter": "就診",
        "infection": "感染控制",
        "licensing": "授權管理",
        "medication": "藥物",
        "notification": "通知",
        "order": "醫囑",
        "patient": "病人",
        "referral": "轉介",
        "research": "研究",
        "restraint": "約束",
        "result": "結果",
        "scheduling": "排程",
        "system": "系統",
        "transfer": "轉科",
        "user": "使用者",
        "schedule": "排程",
        "admin": "管理",
        "report": "報告",
        "other": "其他"
      }
    }
  },
  "category": {
    "form": {
      "addTitle": "建立分類",
      "editTitle": "編輯分類",
      "fields": {
        "name": "分類名稱",
        "code": "分類代碼",
        "description": "描述",
        "sessionTimeout": "工作階段逾時（分鐘）",
        "maxFailedLogins": "最大登入失敗次數",
        "mfaRequired": "此分類需要 MFA"
      },
      "placeholders": {
        "code": "例如 CLINICAL"
      },
      "errors": {
        "nameRequired": "分類名稱不能為空",
        "codeRequired": "分類代碼不能為空"
      },
      "submit": {
        "create": "建立分類",
        "update": "更新分類"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "分類已建立",
        "updatedSuccess": "分類已更新",
        "saveError": "儲存分類失敗"
      }
    },
    "list": {},
    "auditLevel": {
      "none": "無",
      "basic": "基本",
      "full": "完整",
      "paranoid": "嚴格"
    },
    "permissions": {
      "title": "預設權限",
      "titleWithName": "預設權限 — {{name}}",
      "subtitle": "此分類下的角色會繼承這些權限，除非明確拒絕。",
      "invalidCategoryId": "分類 ID 無效。",
      "save": "儲存預設權限",
      "cancel": "取消",
      "toast": {
        "updatedSuccess": "預設權限已更新",
        "saveError": "儲存預設權限失敗"
      }
    }
  },
  "permission": {
    "action": {
      "view": "檢視",
      "viewSelf": "僅檢視本人",
      "viewRestricted": "受限檢視",
      "read": "讀取",
      "write": "寫入",
      "create": "建立",
      "update": "更新",
      "modify": "修改",
      "delete": "刪除",
      "merge": "合併",
      "discharge": "出院",
      "transfer": "轉科",
      "approve": "核准",
      "cosign": "共同簽署",
      "sign": "簽署",
      "plan": "計畫",
      "manage": "管理",
      "all": "全部",
      "breakGlass": "緊急存取",
      "export": "匯出",
      "amend": "修訂",
      "administer": "執行",
      "doubleCheck": "雙人複核",
      "reconcile": "用藥核對",
      "verbalVerify": "口頭醫囑確認",
      "verify": "審核",
      "acknowledge": "確認",
      "prescribe": "處方",
      "dispense": "配藥",
      "cancel": "取消",
      "users": "使用者",
      "roles": "角色",
      "facilities": "機構",
      "system": "系統",
      "audit": "稽核記錄"
    }
  },
  "access": {
    "title": "存取權限矩陣",
    "subtitle": "角色 × 權限對照表",
    "searchPermission": "搜尋權限…",
    "searchRole": "搜尋角色…",
    "categoryFilter": "類別",
    "legend": {
      "own": "自有",
      "inherited": "繼承",
      "category": "類別",
      "denied": "已拒絕",
      "none": "無"
    },
    "cellTooltip": {
      "hasOwn": "直接授予",
      "hasInherited": "繼承自父角色：{{source}}",
      "hasCategory": "透過類別授予：{{source}}",
      "denied": "已明確拒絕",
      "none": "未授予"
    },
    "inheritedFrom": "繼承自 {{source}}",
    "bulkEdit": {
      "title": "批次編輯",
      "applyTo": "套用至所選項目",
      "selectedPermissions": "{{count}} 項權限",
      "selectedRoles": "{{count}} 個角色",
      "actionGrant": "授予",
      "actionDeny": "拒絕",
      "actionClear": "清除",
      "save": "儲存變更",
      "cancel": "取消"
    },
    "emptyRoles": "沒有符合篩選條件的角色。",
    "emptyPermissions": "沒有符合篩選條件的權限。",
    "loading": "正在載入存取權限矩陣…",
    "permissionColumn": "權限",
    "rolePicker": {
      "trigger": "選擇要比較的角色",
      "filterPlaceholder": "篩選角色…",
      "empty": "沒有符合的角色。",
      "groupAll": "全部",
      "groupNone": "無",
      "footerSummary": "已選 {{count}} / {{total}}",
      "selectAll": "全選",
      "clear": "清除"
    },
    "empty": {
      "selectRolesPrompt": "請至少選擇一個角色進行比較。",
      "selectAllRoles": "選擇全部角色",
      "noPermissions": "找不到權限。"
    },
    "legendCategoryDefault": "類別預設",
    "legendNotGranted": "未授予",
    "page": {
      "title": "存取權限矩陣",
      "subtitle": "檢視並管理角色、權限及存取政策"
    },
    "tabs": {
      "matrix": "存取權限矩陣",
      "roles": "角色管理",
      "categories": "類別管理"
    },
    "roles": {
      "searchPlaceholder": "搜尋角色或權限...",
      "createButton": "建立角色",
      "columns": {
        "role": "角色",
        "category": "類別",
        "parent": "父角色",
        "permissions": "權限",
        "users": "使用者",
        "actions": "操作"
      },
      "systemBadge": "系統",
      "managePermissionsTitle": "管理權限",
      "manageDeniedTitle": "管理拒絕權限",
      "deniedBadge": "已拒絕",
      "editTitle": "編輯角色",
      "deleteTitle": "刪除角色",
      "expandAria": "展開角色",
      "collapseAria": "收合角色",
      "effectivePermissions": "有效權限",
      "noPermissionsAssigned": "未指派任何權限。",
      "empty": "找不到角色。",
      "delete": {
        "title": "刪除角色",
        "description": "確定要刪除角色「{{name}}」?此操作無法復原。",
        "confirm": "刪除"
      },
      "toast": {
        "deleted": "角色已刪除",
        "deleteError": "刪除角色失敗"
      }
    },
    "categories": {
      "subtitle": "類別用於分組角色,並定義共用政策 (MFA、工作階段限制等)。",
      "createButton": "建立類別",
      "requireMfa": "要求 MFA",
      "yes": "是",
      "no": "否",
      "sessionTimeout": "工作階段逾時",
      "sessionTimeoutMinutes": "{{count}} 分鐘",
      "maxFailedLogins": "最大失敗登入次數",
      "manageDefaults": "管理預設權限",
      "editTitle": "編輯",
      "editAria": "編輯類別",
      "deleteTitle": "刪除",
      "deleteAria": "刪除類別",
      "empty": "尚未定義任何類別。",
      "delete": {
        "title": "刪除類別",
        "description": "確定要刪除類別「{{name}}」?此操作無法復原。",
        "confirm": "刪除"
      },
      "toast": {
        "deleted": "類別已刪除",
        "deleteError": "刪除類別失敗"
      }
    },
    "confirm": {
      "bulkApply": "將 {{count}} 項變更套用至 {{roleCount}} 個角色?",
      "discardChanges": "捨棄未儲存的變更?"
    },
    "popover": {
      "grantTitle": "授予權限",
      "denyTitle": "拒絕權限",
      "clearTitle": "清除權限",
      "grantNote": "授予此權限將覆寫所有繼承的拒絕設定。",
      "denyNote": "拒絕此權限將覆寫所有繼承的授予。",
      "clearNote": "清除後將還原為繼承行為。"
    },
    "toast": {
      "permissionGranted": "權限已授予",
      "permissionDenied": "權限已拒絕",
      "permissionCleared": "權限已清除",
      "bulkApplied": "批次變更已套用",
      "saveError": "儲存變更失敗"
    }
  },
  "confirm": {
    "restartIntegration": "重新啟動「{{name}}」？載入新的 TLS 材料時，作用中的連線會短暫中斷。",
    "revokeFhirEndpoint": "撤銷「{{name}}」？對此端點的對外呼叫將停止。",
    "rotateSmartSecret": "輪替「{{name}}」的用戶端密鑰？舊密鑰將立即失效。",
    "revokeSmartApp": "撤銷「{{name}}」？此應用程式日後發出的權杖請求將失敗。",
    "deactivateThirdPartyApp": "停用「{{name}}」？"
  },
  "toast": {
    "tierCreated": "層級已建立",
    "tierCloned": "層級已複製",
    "tierDeleted": "層級已刪除",
    "tierStatusUpdated": "狀態已更新",
    "tierFeaturesUpdated": "功能已更新",
    "tierLimitsUpdated": "限額已更新",
    "tierSaveError": "建立層級失敗",
    "tierValidation": "名稱與代碼為必填",
    "licenseKeyGenerated": "授權金鑰已產生",
    "licenseKeyCopied": "授權金鑰已產生並複製到剪貼簿",
    "overridesSaved": "覆寫項已儲存",
    "pricingConfigSaved": "設定已儲存",
    "pricingPriceUpdated": "價格已更新",
    "pricingRuleCreated": "定價規則已建立",
    "addonUpdated": "附加模組已更新",
    "invalidNumber": "請輸入有效的數字",
    "csvExported": "已匯出 {{filename}}",
    "integrationUpdated": "整合已更新",
    "integrationAdded": "整合已新增",
    "integrationInvalidConfig": "設定無效 — 請檢查主機/連接埠與 TLS 欄位",
    "integrationDuplicateName": "已存在同名的整合",
    "integrationSaveFailed": "儲存整合失敗",
    "smartAppRegistered": "SMART 應用程式已註冊",
    "smartAppRegisterFailed": "註冊 SMART 應用程式失敗",
    "smartAppUpdated": "SMART 應用程式已更新",
    "smartAppUpdateFailed": "更新 SMART 應用程式失敗",
    "fhirEndpointUpdated": "端點已更新",
    "fhirEndpointRegistered": "端點已註冊",
    "fhirEndpointInvalidConfig": "設定無效 — 請檢查 base URL 及 auth 欄位",
    "fhirEndpointDuplicateName": "已存在同名端點",
    "fhirEndpointSaveFailed": "儲存端點失敗",
    "clientIdCopied": "Client ID 已複製",
    "clientSecretCopied": "Client secret 已複製",
    "statusRefreshed": "狀態已重新整理",
    "connTestOk": "連線測試成功",
    "connTestFailed": "連線測試失敗 - 請檢查端點設定",
    "serverRestarted": "伺服端已重新啟動 — 新的 TLS 材料已生效",
    "clientReconnected": "用戶端已重新連線 — 新的 TLS 材料已生效",
    "notRunning": "未執行 — 請啟動伺服端/用戶端以套用設定",
    "restartFailed": "重新啟動整合失敗",
    "metadataOk": "/metadata 正常{{detail}}",
    "metadataFailed": "/metadata 失敗：{{error}}",
    "metadataProbeFailed": "探測 /metadata 失敗",
    "metadataUnknownError": "未知",
    "fhirRevoked": "FHIR 端點已撤銷",
    "fhirRevokeFailed": "撤銷端點失敗",
    "smartRevoked": "SMART 應用程式已撤銷",
    "smartRevokeFailed": "撤銷 SMART 應用程式失敗",
    "secretRotated": "用戶端密鑰已輪換",
    "rotateSecretFailed": "輪換密鑰失敗",
    "messageRequeued": "訊息已重新排入佇列等待重試",
    "messageRetryFailed": "重試失敗",
    "messageSkipped": "訊息已略過——佇列將繼續推進",
    "messageSkipFailed": "略過失敗",
    "messageAbandoned": "訊息已放棄",
    "messageAbandonFailed": "放棄失敗",
    "messageResent": "訊息已作為新訊息重送",
    "messageResendFailed": "重送失敗",
    "reasonRequired": "需要填寫原因",
    "copiedToClipboard": "已複製到剪貼簿",
    "thirdPartyAppCreated": "第三方應用程式建立成功",
    "thirdPartyAppUpdated": "第三方應用程式更新成功",
    "thirdPartyAppDeactivated": "第三方應用程式已停用",
    "thirdPartyAppLaunchUrl": "已產生啟動 URL：{{url}}"
  },
  "facility": {
    "form": {
      "addTitle": "新增機構",
      "editTitle": "編輯機構",
      "fields": {
        "name": "名稱",
        "code": "代碼",
        "type": "類型",
        "address": "地址",
        "city": "城市",
        "stateProvince": "省／州",
        "country": "國家",
        "phone": "電話",
        "timeZone": "時區",
        "healthSystem": "Health System",
        "visibilityScope": "Patient visibility override",
        "visibilityScopeDesc": "Narrow or widen patient visibility for this facility. The stricter side always wins between the user's and the patient's facility. Takes effect immediately.",
        "visibilityInherit": "Inherit global default"
      },
      "placeholders": {
        "timeZone": "例如：Asia/Bangkok",
        "healthSystem": "Select a health system"
      },
      "helper": {
        "timeZone": "IANA 時區名稱（例如：Asia/Singapore）。用於住院人數、MAR 與報表中的機構本地日期。"
      },
      "options": {
        "otherIana": "其他（IANA）…",
        "useCuratedList": "使用預設清單"
      },
      "errors": {
        "nameMin": "機構名稱至少需要 {{min}} 個字元",
        "codeFormat": "代碼僅能包含大寫字母與數字",
        "typeRequired": "機構類型為必填",
        "countryRequired": "國家為必填",
        "timeZoneRequired": "時區為必填",
        "timeZoneInvalidIana": "伺服器拒絕此時區。請使用有效的 IANA 名稱（例如：Asia/Singapore）。",
        "healthSystemRequired": "Health system is required"
      },
      "submit": {
        "create": "建立",
        "update": "更新"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "機構已建立",
        "updatedSuccess": "機構已更新",
        "saveError": "儲存機構失敗",
        "invalidTimeZone": "請求無效 — 請檢查時區是否為有效的 IANA 名稱（例如：Asia/Singapore）。"
      },
      "memberships": {
        "title": "Group Memberships",
        "columns": {
          "group": "Group",
          "role": "Role",
          "effective": "Effective",
          "end": "End",
          "status": "Status",
          "actions": "Actions"
        },
        "add": {
          "healthSystem": "Health system",
          "role": "Role",
          "effective": "Effective date",
          "end": "End date (optional)",
          "submit": "Add membership"
        },
        "roles": {
          "primary": "Primary",
          "member": "Member",
          "partner": "Partner"
        },
        "endMembership": "End membership",
        "toast": {
          "createdSuccess": "Membership added",
          "updatedSuccess": "Membership updated",
          "endedSuccess": "Membership ended",
          "saveError": "Failed to save membership",
          "conflict": "An open membership for this facility and group already exists"
        }
      },
      "__review_healthSystem": "EN placeholder — needs translation"
    },
    "list": {
      "title": "機構管理",
      "subtitle": "機構、科室及（透過此樹）實體位置層級的概覽。如需查看完整的位置樹（建築 → 樓層 → 單位 → 房間 → 病床），請前往<locationsLink>位置管理</locationsLink>。",
      "columns": {
        "name": "名稱",
        "code": "代碼",
        "type": "類型",
        "address": "地址",
        "phone": "電話",
        "depts": "科室數",
        "status": "狀態",
        "actions": "操作"
      },
      "filter": {
        "search": "搜尋機構..."
      },
      "actions": {
        "new": "新增機構",
        "editTitle": "編輯"
      },
      "expand": {
        "expand": "展開機構",
        "collapse": "收合機構"
      },
      "empty": {
        "noMatch": "找不到符合搜尋的機構。",
        "none": "尚未有機構 — 點選「新增機構」即可開始。"
      },
      "departments": {
        "title": "科室",
        "add": "新增科室",
        "empty": "尚未設定科室",
        "locationsCount": "{{count}} 個位置",
        "editTitle": "編輯科室"
      },
      "locations": {
        "title": "位置",
        "add": "新增",
        "empty": "此科室尚未有位置。位置樹（建築 → 樓層 → 單位 → 病床）於<locationsLink>位置管理</locationsLink>中設定。"
      }
    },
    "type": {
      "generalHospital": "綜合醫院",
      "teachingHospital": "教學醫院",
      "specialtyHospital": "專科醫院",
      "communityHospital": "社區醫院",
      "clinic": "診所"
    },
    "status": {
      "active": "啟用",
      "inactive": "停用"
    }
  },
  "healthSystem": {
    "form": {
      "addTitle": "建立醫療機構",
      "editTitle": "編輯醫療機構",
      "subtitle": "組織架構的最上層。下轄一個或多個醫療單位。",
      "sections": {
        "identity": "基本資料",
        "primaryContact": "主要聯絡人",
        "address": "地址"
      },
      "fields": {
        "code": "代碼",
        "name": "名稱",
        "taxId": "稅號",
        "contactName": "姓名",
        "contactEmail": "電子郵件",
        "contactPhone": "電話",
        "addressLine1": "地址第一行",
        "addressLine2": "地址第二行",
        "city": "城市",
        "stateProvince": "縣市/州",
        "postalCode": "郵遞區號",
        "country": "國家/地區",
        "active": "啟用 — 取消勾選可停用此機構。"
      },
      "placeholders": {
        "code": "VYNAEMR-SG",
        "name": "VynaEMR Singapore",
        "taxId": "UEN / Tax ID",
        "country": "SG"
      },
      "helper": {
        "codeImmutable": "代碼建立後不可修改。"
      },
      "errors": {
        "codeRequired": "請輸入代碼",
        "nameRequired": "請輸入名稱"
      },
      "submit": {
        "create": "建立醫療機構",
        "update": "儲存變更"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "醫療機構建立成功",
        "updatedSuccess": "醫療機構更新成功",
        "saveError": "儲存醫療機構失敗",
        "codeConflict": "此機構代碼已存在",
        "invalidData": "醫療機構資料無效"
      }
    },
    "list": {
      "title": "醫療機構",
      "subtitle": "組織樹的最上層 — 擁有一個或多個院區的企業／醫療機構母組織。初始設定後鮮少變更。",
      "columns": {
        "name": "名稱",
        "code": "代碼",
        "contact": "聯絡方式",
        "location": "位置",
        "facilities": "院區數",
        "status": "狀態",
        "actions": "操作"
      },
      "filter": {
        "search": "依名稱或代碼搜尋..."
      },
      "actions": {
        "new": "建立醫療機構",
        "editTitle": "編輯"
      },
      "status": {
        "active": "啟用",
        "inactive": "停用"
      },
      "empty": {
        "noMatch": "找不到符合搜尋的醫療機構。",
        "none": "尚未有醫療機構 — 點選「建立醫療機構」即可開始。"
      }
    }
  },
  "location": {
    "form": {
      "addTitle": "建立位置",
      "editTitle": "編輯位置",
      "subtitle": "實體位置——大樓、樓層、單位、房間或床位。相容於 FHIR R4 Location。透過上層位置進行巢狀以建立層級樹。",
      "sections": {
        "hierarchy": "層級",
        "identity": "識別",
        "classification": "分類",
        "physicalAttributes": "實體屬性"
      },
      "fields": {
        "facility": "機構",
        "parentLocation": "上層位置",
        "department": "科別（選填）",
        "code": "代碼",
        "abbreviation": "簡稱",
        "name": "名稱",
        "physicalType": "實體類型（FHIR）",
        "clinicalType": "臨床類型",
        "status": "狀態（FHIR）",
        "operationalStatus": "運作狀態（HL7 0116）",
        "building": "大樓",
        "floor": "樓層",
        "wing": "區翼",
        "roomNumber": "房間號碼",
        "bedIdentifier": "床位識別碼",
        "capacity": "容量",
        "active": "啟用（舊標記）"
      },
      "placeholders": {
        "facility": "選擇機構…",
        "parentNone": "無（最上層）",
        "departmentNone": "無",
        "code": "4W-12-A",
        "name": "4W-12 床位 A",
        "building": "A",
        "floor": "4",
        "wing": "West",
        "roomNumber": "4W-12",
        "bedIdentifier": "A"
      },
      "helper": {
        "physicalType": "FHIR LocationPhysicalType 值集。",
        "clinicalType": "舊欄位；service_type 上線後移除。"
      },
      "physicalAttributes": {
        "show": "展開 ▾",
        "hide": "收起 ▴"
      },
      "errors": {
        "facilityRequired": "請選擇機構",
        "codeRequired": "請輸入代碼",
        "nameRequired": "請輸入名稱"
      },
      "submit": {
        "create": "建立位置",
        "update": "儲存變更"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "位置建立成功",
        "updatedSuccess": "位置更新成功",
        "saveError": "儲存位置失敗",
        "codeConflict": "此位置代碼已存在",
        "invalidData": "位置資料無效"
      }
    },
    "list": {
      "title": "位置層級",
      "subtitle": "實體樹狀結構：建築 → 樓層 → 單位 → 房間 → 床位。與 FHIR LocationPhysicalType 對齊。點擊床位狀態標記可循環切換佔用情況。機構與科室於 <facilitiesLink>機構</facilitiesLink> 中管理。",
      "filter": {
        "search": "依名稱或代碼搜尋...",
        "allFacilities": "全部機構"
      },
      "actions": {
        "new": "新增位置",
        "addChildTitle": "新增子項",
        "editTitle": "編輯"
      },
      "expand": {
        "expand": "展開位置",
        "collapse": "收合位置"
      },
      "bed": {
        "toggleTitle": "點擊切換為 {{next}}"
      },
      "empty": {
        "noMatch": "沒有符合該搜尋的位置。",
        "none": "此機構尚未建立位置。"
      },
      "toast": {
        "bedStatusUpdated": "床位狀態已更新",
        "bedStatusError": "更新床位狀態失敗"
      }
    },
    "type": {
      "si": "院區",
      "bu": "建築",
      "wi": "側翼",
      "wa": "病房",
      "lvl": "樓層",
      "co": "走廊",
      "ro": "房間",
      "bd": "床位",
      "ve": "虛擬",
      "ho": "住所",
      "ca": "櫃",
      "rd": "道路",
      "area": "區域",
      "jdn": "轄區"
    },
    "clinicalType": {
      "examRoom": "診間",
      "inpatientBed": "住院床位",
      "procedureRoom": "操作室",
      "icu": "ICU",
      "ed": "急診",
      "or": "手術室",
      "virtual": "虛擬"
    },
    "status": {
      "active": "啟用",
      "suspended": "暫停",
      "inactive": "停用",
      "op": {
        "O": "已佔用",
        "U": "空置",
        "H": "清潔中",
        "K": "已污染",
        "I": "隔離",
        "C": "關閉"
      }
    },
    "capability": {
      "isolation": "可隔離",
      "negativePressure": "負壓",
      "bariatric": "可減重（肥胖症）",
      "telemetry": "可遙測",
      "icu": "ICU 級別"
    }
  },
  "department": {
    "form": {
      "addTitle": "新增科別",
      "editTitle": "編輯科別",
      "subtitle": "院區下的組織單位。可以巢狀（例如：心臟科 → 電生理實驗室），透過上層科別設定。",
      "sections": {
        "department": "科別"
      },
      "fields": {
        "facility": "院區",
        "code": "代碼",
        "abbreviation": "縮寫",
        "name": "名稱",
        "type": "類型",
        "parentDepartment": "上層科別",
        "costCenterCode": "成本中心代碼",
        "revenueDepartmentCode": "收入科別代碼",
        "active": "啟用 — 取消勾選可停用此科別。"
      },
      "placeholders": {
        "facility": "選擇院區…",
        "code": "CARDIO",
        "abbreviation": "CARD",
        "name": "心臟科",
        "parentNone": "無（頂層）",
        "typeNone": "—",
        "costCenterCode": "CC-CARDIO",
        "revenueDepartmentCode": "RD-410"
      },
      "errors": {
        "facilityRequired": "請選擇院區",
        "codeRequired": "請輸入代碼",
        "nameRequired": "請輸入名稱"
      },
      "submit": {
        "create": "建立科別",
        "update": "儲存變更"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "科別建立成功",
        "updatedSuccess": "科別更新成功",
        "saveError": "儲存科別失敗",
        "codeConflict": "此科別代碼已存在",
        "invalidData": "科別資料無效"
      }
    },
    "serviceType": {
      "clinical": "臨床",
      "administrative": "行政",
      "support": "輔助"
    },
    "status": {
      "active": "啟用",
      "inactive": "停用"
    }
  },
  "provider": {
    "form": {
      "addTitle": "建立醫事人員",
      "editTitle": "編輯醫事人員",
      "fields": {
        "fullName": "姓名",
        "npi": "NPI",
        "providerType": "醫療人員類型",
        "credentials": "資格證書",
        "specialty": "專科",
        "email": "電子郵件",
        "phone": "電話",
        "facilityAssignments": "機構指派",
        "status": "狀態",
        "primaryFacility": "主要機構",
        "loginAccount": "登入帳戶"
      },
      "placeholders": {
        "specialty": "請選擇專科…",
        "credentials": "例如：MD、FACC",
        "providerType": "選擇醫療人員類型",
        "noLoginAccount": "無登入帳戶"
      },
      "submit": {
        "create": "建立",
        "update": "更新"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已建立醫事人員",
        "updatedSuccess": "已更新醫事人員",
        "saveError": "醫事人員儲存失敗"
      },
      "hints": {
        "loginAccount": "將該臨床人員與其登入帳戶連結。未連結時，會簽、藥師核對與危急值確認都會拒絕該使用者。"
      }
    },
    "list": {
      "title": "醫師管理",
      "subtitle": "管理醫師、資格與院所派任",
      "columns": {
        "name": "姓名",
        "npi": "NPI",
        "specialty": "專科",
        "credentials": "資格",
        "facilities": "院所",
        "status": "狀態",
        "actions": "操作"
      },
      "filter": {
        "search": "依姓名、NPI、專科搜尋…",
        "allSpecialties": "所有專科",
        "allFacilities": "所有院所",
        "allStatus": "所有狀態"
      },
      "actions": {
        "new": "新增醫師",
        "editTitle": "編輯醫師",
        "scheduleTitle": "排班範本",
        "viewCredentials": "檢視資格"
      },
      "credentials": {
        "licenseLabel": "執照",
        "none": "無在檔資格"
      },
      "empty": "找不到醫師",
      "pagination": {
        "summary": "第 {{from}}-{{to}} 筆，共 {{total}} 筆",
        "pageOf": "{{page}}/{{totalPages}}",
        "previous": "上一頁",
        "next": "下一頁"
      },
      "toast": {
        "schedulePlaceholder": "排班範本連結（佔位符）"
      },
      "noLogin": "無登入",
      "noLoginHint": "該醫事人員未連結登入帳戶，無法進行會簽、核對或確認。"
    },
    "specialty": {
      "internalMedicine": "內科",
      "cardiology": "心臟內科",
      "emergencyMedicine": "急診醫學科",
      "pediatrics": "兒科",
      "pathology": "病理科",
      "obstetricsGynecology": "婦產科",
      "surgery": "外科",
      "orthopedics": "骨科",
      "neurology": "神經內科",
      "psychiatry": "精神科",
      "radiology": "放射科",
      "anesthesiology": "麻醉科",
      "oncology": "腫瘤科",
      "dermatology": "皮膚科",
      "ophthalmology": "眼科"
    },
    "status": {
      "active": "在職",
      "inactive": "停用",
      "onLeave": "休假中"
    },
    "providerType": {
      "physician": "醫師",
      "nurse": "護理師",
      "nursePractitioner": "專科護理師",
      "physicianAssistant": "醫師助理",
      "pharmacist": "藥師",
      "therapist": "治療師",
      "technician": "技術員",
      "other": "其他",
      "midwife": "助產師",
      "dentist": "牙醫師",
      "pharmacyTechnician": "藥劑技術員",
      "careAssistant": "照顧服務員",
      "dietitian": "營養師",
      "socialWorker": "社會工作師",
      "traditionalMedicine": "中醫師"
    }
  },
  "serviceLine": {
    "form": {
      "addTitle": "新增服務線",
      "editTitle": "編輯服務線",
      "subtitle": "高層臨床分組(心血管、腫瘤學),作為具體臨床服務的上級。",
      "sections": {
        "serviceLine": "服務線"
      },
      "fields": {
        "healthSystem": "醫療系統",
        "code": "代碼",
        "name": "名稱",
        "description": "說明",
        "active": "啟用 — 取消勾選即軟停用。"
      },
      "placeholders": {
        "healthSystem": "選擇醫療系統…",
        "code": "CV",
        "name": "Cardiovascular",
        "description": "簡短描述 — 範圍、疾病重點等。"
      },
      "errors": {
        "healthSystemRequired": "醫療系統為必填項",
        "codeRequired": "代碼為必填項",
        "nameRequired": "名稱為必填項"
      },
      "submit": {
        "create": "建立服務線",
        "update": "儲存變更"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已建立服務線",
        "updatedSuccess": "已更新服務線",
        "saveError": "儲存服務線失敗",
        "codeConflict": "服務線代碼已存在",
        "invalidData": "服務線資料無效"
      }
    },
    "category": {}
  },
  "clinicalService": {
    "form": {
      "addTitle": "新增臨床服務",
      "editTitle": "編輯臨床服務",
      "subtitle": "具體的臨床服務(心臟內科、EP 實驗室)。可選擇歸入服務線之下,並附加 NUCC 專科代碼,用於計費與目錄輸出。",
      "sections": {
        "clinicalService": "臨床服務",
        "specialtyBilling": "專科 + 計費"
      },
      "fields": {
        "code": "代碼",
        "name": "名稱",
        "serviceLine": "服務線",
        "description": "說明",
        "specialtyCode": "NUCC 專科代碼",
        "specialtyDescription": "專科說明",
        "revenueDepartmentCode": "收入部門代碼",
        "active": "啟用"
      },
      "placeholders": {
        "code": "CARDIO-EP",
        "name": "Electrophysiology",
        "serviceLineNone": "— 無 —",
        "specialtyCode": "207RE0101X",
        "specialtyDescription": "Clinical Cardiac Electrophysiology",
        "revenueDepartmentCode": "RD-480"
      },
      "helper": {
        "specialtyCode": "NUCC 分類 — 驅動醫事人員目錄與理賠單據呈現。"
      },
      "errors": {
        "codeRequired": "代碼為必填項",
        "nameRequired": "名稱為必填項"
      },
      "submit": {
        "create": "建立臨床服務",
        "update": "儲存變更"
      },
      "cancel": "取消",
      "toast": {
        "createdSuccess": "已建立臨床服務",
        "updatedSuccess": "已更新臨床服務",
        "saveError": "儲存臨床服務失敗",
        "codeConflict": "臨床服務代碼已存在",
        "invalidData": "臨床服務資料無效"
      }
    },
    "flag": {}
  },
  "serviceLocation": {
    "title": "服務 ↔ 地點指派",
    "subtitle": "哪些臨床服務在哪些實體地點執行,可選日/時段視窗與容量。排程據此產生可預約時段。僅軟刪除 — 結束指派會保留歷史以供報表使用。",
    "header": {
      "newAssignment": "新增指派",
      "toggleCancel": "取消"
    },
    "form": {
      "title": "新增指派",
      "fields": {
        "service": "臨床服務",
        "location": "地點",
        "dayOfWeekPattern": "星期模式",
        "startTime": "開始時間",
        "endTime": "結束時間",
        "capacity": "容量 %",
        "notes": "備註",
        "isPrimary": "作為此服務的主要地點"
      },
      "placeholders": {
        "service": "選擇服務…",
        "location": "選擇地點…",
        "dayOfWeekPattern": "1,3,5(週一/週三/週五)",
        "capacity": "0–100"
      },
      "helper": {
        "dayOfWeekPattern": "逗號分隔的 ISO 星期;留空表示每天。"
      },
      "errors": {
        "serviceLocationRequired": "服務與地點為必填項"
      },
      "create": "建立",
      "cancel": "取消"
    },
    "filter": {
      "allFacilities": "全部機構",
      "allServices": "全部服務",
      "allLocations": "全部地點",
      "allStatuses": "全部狀態",
      "searchService": "搜尋服務…",
      "searchLocation": "搜尋地點…",
      "facility": "機構",
      "serviceLine": "服務線"
    },
    "columns": {
      "service": "服務",
      "location": "地點",
      "facility": "機構",
      "when": "時間",
      "capacity": "容量",
      "effective": "生效",
      "status": "狀態",
      "actions": "操作"
    },
    "status": {
      "active": "啟用",
      "planned": "計畫中",
      "suspended": "已暫停",
      "ended": "已結束"
    },
    "dow": {
      "everyDay": "每天",
      "monFri": "週一至週五",
      "short": {
        "1": "週一",
        "2": "週二",
        "3": "週三",
        "4": "週四",
        "5": "週五",
        "6": "週六",
        "7": "週日"
      }
    },
    "cell": {
      "none": "—",
      "primaryAria": "主要地點",
      "effectiveEndPrefix": "→ {{date}}"
    },
    "actions": {
      "setPrimary": "設為主要",
      "unsetPrimary": "取消主要",
      "endAssignment": "結束指派"
    },
    "bulkEdit": {
      "title": "批次編輯",
      "applyTo": "套用至所選",
      "selectedServices": "{{count}} 個服務",
      "selectedLocations": "{{count}} 個地點",
      "save": "儲存變更",
      "cancel": "取消"
    },
    "confirm": {
      "endTitle": "結束指派?",
      "endDescription": "{{service}} → {{location}}。結束會保留歷史,但會將此配對從有效排程中移除。",
      "endConfirm": "結束指派",
      "removeService": "將 {{service}} 從 {{location}} 移除?",
      "makePrimary": "將 {{location}} 設為 {{service}} 的主要地點?"
    },
    "toast": {
      "created": "已建立指派",
      "createError": "建立指派失敗",
      "ended": "已結束指派",
      "endError": "結束指派失敗",
      "primaryError": "切換主要地點失敗",
      "updated": "已更新指派"
    },
    "empty": "沒有符合這些篩選條件的指派。點選「新增指派」以新增一筆。"
  },
  "integration": {
    "list": {
      "title": "整合管理",
      "subtitle": "HL7、FHIR 及第三方系統整合",
      "refresh": "重新整理",
      "addEndpoint": "新增端點",
      "searchPlaceholder": "搜尋整合…",
      "tabs": {
        "endpoints": "端點",
        "messageLog": "訊息記錄",
        "fhirSmart": "FHIR / SMART"
      },
      "cards": {
        "totalEndpoints": "端點總數",
        "connected": "已連線",
        "errors": "錯誤",
        "totalMessages": "訊息總數"
      }
    },
    "columns": {
      "status": "狀態",
      "name": "名稱",
      "type": "類型",
      "direction": "方向",
      "url": "URL",
      "tls": "TLS",
      "auth": "驗證",
      "lastMessage": "最近訊息",
      "messages": "訊息數",
      "errors": "錯誤數",
      "backlog": "積壓",
      "health": "健康狀況",
      "actions": "操作",
      "backlogTitle": "待傳送的出站訊息 + 最早待處理訊息的等待時間",
      "healthTitle": "健康狀態 — 若佇列因某筆失敗訊息而阻塞則顯示紅色"
    },
    "badge": {
      "tlsCerts": "憑證：{{cert}}，金鑰：{{key}}，CA：{{ca}}",
      "yes": "是",
      "no": "否",
      "basicTitle": "basic（{{username}}）",
      "bearerStored": "已儲存 Bearer 權杖",
      "bearerNoToken": "bearer（未設定權杖）",
      "mtlsCert": "mTLS 用戶端憑證",
      "awaitingAck": "{{n}} 筆等待 ACK",
      "oldest": "最早 {{age}}",
      "never": "從未",
      "blocked": "已阻塞",
      "waiting": "等待中",
      "ok": "正常",
      "blockedTitle": "一筆失敗訊息正在阻塞此整合的佇列。點擊開啟已篩選的記錄。",
      "waitingTitle": "正在等待合作夥伴回傳增強模式應用程式 ACK 的訊息。點擊開啟已篩選的記錄。",
      "okTitle": "一切正常 — 點擊開啟此整合的訊息記錄。",
      "receives": "接收"
    },
    "action": {
      "testConnection": "測試連線",
      "restartTls": "重新啟動 — 套用剛輪換的 TLS",
      "investigate": "輸送量、延遲與近期失敗",
      "edit": "編輯"
    },
    "auth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "mtls": "mTLS"
    },
    "fhirAuth": {
      "basic": "Basic",
      "bearer": "Bearer",
      "oauth2": "OAuth2",
      "mtls": "mTLS"
    },
    "messages": {
      "recent50": "最近 50 筆訊息",
      "columns": {
        "time": "時間",
        "id": "ID",
        "direction": "方向",
        "type": "類型",
        "source": "來源",
        "summary": "摘要",
        "status": "狀態"
      },
      "dir": {
        "in": "入",
        "out": "出"
      }
    },
    "fhir": {
      "serverStatusHeader": "FHIR R4 伺服器狀態",
      "serverOnline": "伺服器上線",
      "supportedResources": "支援的資源",
      "version": "版本",
      "externalHeader": "外部 FHIR 端點",
      "registerEndpoint": "註冊端點",
      "columns": {
        "name": "名稱",
        "baseUrl": "基礎 URL",
        "auth": "驗證",
        "status": "狀態",
        "lastChecked": "最近檢查",
        "actions": "操作"
      },
      "emptyEndpoints": "尚未註冊任何外部 FHIR 端點。",
      "revoked": "已撤銷",
      "statusOk": "正常",
      "statusError": "錯誤",
      "testMetadata": "測試 /metadata",
      "edit": "編輯",
      "revoke": "撤銷"
    },
    "smart": {
      "header": "已註冊的 SMART 應用程式",
      "registerApp": "註冊應用程式",
      "columns": {
        "appName": "應用程式名稱",
        "clientId": "Client ID",
        "scopes": "權限範圍",
        "status": "狀態",
        "lastModified": "最近修改",
        "actions": "操作"
      },
      "emptyApps": "尚未註冊任何 SMART 應用程式。",
      "edit": "編輯",
      "rotateSecret": "輪換用戶端密鑰",
      "revoke": "撤銷"
    },
    "secretModal": {
      "title": "請立即儲存此 client secret",
      "body": "此密鑰僅顯示一次。若遺失，請輪換密鑰以重新簽發。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "複製 Client ID",
      "copyClientSecret": "複製 Client Secret",
      "saved": "我已儲存"
    },
    "drawer": {
      "header": "整合 #{{id}}",
      "refresh": "重新整理",
      "close": "關閉",
      "queueBlocked": "佇列已封鎖",
      "queueBlockedBody": "一則失敗的訊息正阻止此整合傳送。其後的訊息將持續等待，直到操作員處理。",
      "investigate": "調查",
      "tiles": {
        "backlog": "積壓",
        "success24h": "24h 成功率",
        "avgLatency24h": "24h 平均延遲",
        "awaitingAck": "等待 app-ACK"
      },
      "charts": {
        "throughput": "吞吐量（24h）",
        "throughputSub": "以小時分組。堆疊：傳出已完成 + 失敗；傳入位於次座標軸。",
        "successRate": "成功率（24h）",
        "successRateSub": "依每組統計：已完成 /（已完成 + 失敗）。空缺為閒置時段。",
        "ackLatency": "ACK 延遲（24h）",
        "ackLatencySub": "傳送至收到 ACK 之間的時間。avg 為實線，p95 為虛線。"
      },
      "series": {
        "outCompleted": "傳出 · 已完成",
        "outFailed": "傳出 · 失敗",
        "inReceived": "傳入 · 已接收",
        "successPct": "成功率 %",
        "avg": "avg",
        "p95": "p95"
      },
      "recentFailures": "近期失敗",
      "viewAll": "檢視全部 →",
      "noFailures": "近期時段內沒有失敗訊息。🎉"
    }
  },
  "integrationStatus": {
    "connected": "已連線",
    "disconnected": "已中斷",
    "error": "錯誤"
  },
  "integrationDirection": {
    "server": "伺服端",
    "client": "用戶端"
  },
  "messageStatus": {
    "sent": "已傳送",
    "received": "已接收",
    "error": "錯誤",
    "acknowledged": "已確認"
  },
  "smartAppStatus": {
    "active": "啟用",
    "revoked": "已撤銷"
  },
  "interfaceMessageStatus": {
    "pending": "待處理",
    "processing": "處理中",
    "completed": "已完成",
    "received": "已接收",
    "processed": "已處理",
    "failed": "失敗",
    "error": "錯誤",
    "rejected": "已拒絕",
    "deadLetter": "無效信件",
    "skipped": "已略過",
    "awaitingAppAck": "等待應用程式 ACK"
  },
  "interfaceDirection": {
    "in": "傳入",
    "out": "傳出"
  },
  "attemptOutcome": {
    "sent": "已傳送",
    "appNak": "應用 NAK",
    "timeout": "逾時",
    "networkError": "網路錯誤"
  },
  "fhirEndpoint": {
    "titleEdit": "編輯 FHIR 端點",
    "titleRegister": "註冊 FHIR 端點",
    "subtitle": "閘道對外通訊的外部 FHIR R4 合作夥伴。整合清單上的 Test Connection 按鈕會使用已設定的 auth + TLS 探測 <code>/metadata</code>。",
    "back": "返回",
    "cancel": "取消",
    "storedBlank": "已儲存 — 留空以保留",
    "save": {
      "changes": "儲存變更",
      "register": "註冊端點"
    },
    "section": {
      "basics": "基本資料",
      "auth": "驗證",
      "tls": "TLS"
    },
    "fields": {
      "name": "名稱",
      "baseUrl": "Base URL",
      "description": "說明",
      "active": "啟用 — 取消勾選以軟撤銷。",
      "method": "方式",
      "username": "使用者名稱",
      "password": "密碼",
      "bearerToken": "Bearer token",
      "tokenUrl": "Token URL",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "scope": "Scope"
    },
    "placeholder": {
      "name": "Partner Hospital FHIR",
      "baseUrl": "https://partner.example.com/fhir/R4",
      "tokenUrl": "https://partner.example.com/oauth/token",
      "scope": "system/*.read"
    },
    "helper": {
      "baseUrl": "需要 https://（開發環境接受 http://localhost）。Test 期間會自動附加結尾的 /metadata。",
      "oauth2": "OAuth2 權杖取得已在管理端接入；執行階段擷取器將於後續版本提供。目前請填寫值並執行 Test 以驗證其餘設定。",
      "tls": "貼上根 CA 以釘選合作夥伴的伺服器憑證，或貼上 client cert + key 用於 mTLS。對於知名 CA，僅 CA 即可與系統根儲存區搭配使用。"
    },
    "option": {
      "method": {
        "none": "無",
        "basic": "HTTP Basic",
        "bearer": "Bearer token",
        "oauth2": "OAuth2 client_credentials",
        "clientCert": "Client certificate (mTLS)"
      }
    },
    "tlsLabel": {
      "ca": "Server CA (PEM) — 對大多數合作夥伴為選用",
      "clientCertRequired": "Client certificate (PEM) — 必填",
      "clientCertMtls": "Client certificate (PEM) — 用於 mTLS",
      "clientKeyRequired": "Client private key (PEM) — 必填",
      "clientKeyOptional": "Client private key (PEM)"
    },
    "validation": {
      "nameRequired": "名稱為必填項",
      "baseUrlRequired": "Base URL 為必填項",
      "baseUrlInvalid": "基礎 URL 必須是有效的 http(s) 位址",
      "basicUsername": "Basic auth 需要使用者名稱",
      "basicPassword": "Basic auth 需要密碼",
      "bearerToken": "Bearer auth 需要 token",
      "clientCertKey": "Client-certificate auth 需要 cert + key"
    }
  },
  "smartApp": {
    "titleEdit": "編輯 SMART 應用程式",
    "titleRegister": "註冊 SMART 應用程式",
    "subtitle": "SMART on FHIR 用戶端註冊。Client ID 由系統自動產生；client secret 在建立或輪換後僅顯示一次。",
    "back": "返回",
    "cancel": "取消",
    "save": "儲存變更",
    "register": "註冊",
    "fields": {
      "appName": "應用程式名稱",
      "redirectUris": "重新導向 URI",
      "scopes": "權限範圍",
      "launchUrl": "啟動 URL",
      "logoUrl": "Logo URL",
      "active": "啟用 — 取消勾選可軟撤銷此應用程式。"
    },
    "placeholder": {
      "appName": "我的 EHR 啟動器"
    },
    "helper": {
      "redirectUris": "每行一個 URI。需使用 https://（開發環境也接受 http://localhost）。"
    },
    "secretModal": {
      "title": "請立即儲存此 client secret",
      "body": "此密鑰僅顯示一次。若遺失，請輪換密鑰以重新簽發。",
      "clientId": "Client ID",
      "clientSecret": "Client Secret",
      "copyClientId": "複製 Client ID",
      "copyClientSecret": "複製 Client Secret",
      "saved": "我已儲存"
    },
    "validation": {
      "nameRequired": "名稱為必填項",
      "redirectUriRequired": "至少需要一個重新導向 URI",
      "scopeRequired": "至少需要一個權限範圍"
    }
  },
  "interfaceLog": {
    "list": {
      "title": "介面訊息記錄",
      "subtitle": "所有作用中整合的傳入與傳出 HL7 訊息。",
      "refresh": "重新整理",
      "loading": "正在載入訊息…",
      "empty": "沒有符合目前篩選條件的訊息。",
      "pagination": "{{total}} 則訊息 • 第 {{page}} / {{pages}} 頁",
      "prev": "上一頁",
      "next": "下一頁",
      "archived": "(封存)"
    },
    "relative": {
      "secondsAgo": "{{n}} 秒前",
      "minutesAgo": "{{n}} 分鐘前",
      "hoursAgo": "{{n}} 小時前"
    },
    "filter": {
      "header": "篩選",
      "direction": "方向",
      "status": "狀態",
      "messageType": "訊息類型",
      "msh10": "MSH-10 包含",
      "integrationId": "整合 ID",
      "includeArchive": "包含封存",
      "clear": "清除篩選",
      "any": "任何",
      "messageTypePlaceholder": "例如 ADT^A01",
      "controlIdPlaceholder": "控制 ID"
    },
    "columns": {
      "id": "ID",
      "dir": "方向",
      "integ": "整合",
      "type": "類型",
      "msh10": "MSH-10",
      "status": "狀態",
      "ack": "ACK",
      "attempts": "嘗試",
      "when": "時間"
    },
    "detail": {
      "eyebrow": "{{direction}}訊息",
      "close": "關閉",
      "loading": "正在載入…",
      "tabs": {
        "overview": "概覽",
        "rawHl7": "原始 HL7",
        "attempts": "嘗試"
      },
      "operatorActions": "操作員操作",
      "retry": "重試",
      "skip": "略過",
      "abandon": "放棄",
      "resendAsNew": "作為新訊息重送",
      "skipReason": "略過原因",
      "abandonReason": "放棄原因",
      "actionsHelper": "操作會連同您的使用者 ID 與原因一併稽核。略過與放棄需要填寫原因。",
      "overview": {
        "direction": "方向",
        "integration": "整合",
        "type": "類型",
        "msh10": "MSH-10",
        "status": "狀態",
        "ackCode": "ACK 代碼",
        "attempts": "嘗試",
        "created": "建立時間",
        "ackReceived": "收到 ACK",
        "nextRetry": "下次重試",
        "ackText": "ACK 文字",
        "lastError": "最後錯誤",
        "sourceEventId": "來源事件 ID"
      },
      "rawViewer": {
        "permissionDenied": "解密後的原始 HL7 需要 <code>INTERFACE_OPERATE</code> 權限。",
        "notAvailable": "此訊息沒有可用的原始負載。",
        "bytes": "{{bytes}} 位元組",
        "copy": "複製"
      },
      "attempts": {
        "inboundInfo": "嘗試歷史僅針對傳出訊息進行追蹤。傳入訊息按 MSH-10 處理一次；重傳將返回快取的 ACK，不會產生新的嘗試。",
        "totalAttempts": "嘗試總數",
        "nextAt": "（下次於 {{time}}）",
        "refresh": "重新整理",
        "loading": "正在載入嘗試…",
        "error": "載入嘗試失敗。",
        "empty": "尚未記錄任何嘗試。工作程序每次傳送寫入一列；首次認領後此清單將填入。",
        "columns": {
          "when": "時間",
          "outcome": "結果",
          "ack": "ACK",
          "duration": "持續時間",
          "detail": "詳情"
        }
      }
    }
  },
  "thirdPartyApp": {
    "list": {
      "title": "第三方應用程式",
      "subtitle": "設定可從 VynaEMR 攜帶病患內容啟動的外部應用程式",
      "addApp": "新增應用程式",
      "searchPlaceholder": "依名稱、代碼或類別搜尋應用程式...",
      "emptyTitle": "未設定任何應用程式",
      "emptyBody": "新增外部應用程式，例如 PACS 檢視器、檢驗入口網站或藥局系統。",
      "columns": {
        "application": "應用程式",
        "category": "類別",
        "url": "URL",
        "security": "安全",
        "display": "顯示",
        "status": "狀態",
        "actions": "操作"
      }
    },
    "badge": {
      "jwt": "JWT",
      "jwtSigned": "JWT 已簽署",
      "hmac": "HMAC",
      "hmacSigned": "HMAC 已簽署",
      "none": "無",
      "chart": "圖表",
      "sidebar": "側邊欄",
      "active": "啟用",
      "inactive": "停用"
    },
    "action": {
      "testLaunch": "測試啟動",
      "edit": "編輯",
      "deactivate": "停用"
    },
    "form": {
      "titleEdit": "編輯應用程式",
      "titleNew": "新增應用程式",
      "fields": {
        "appCode": "應用程式代碼",
        "appName": "應用程式名稱",
        "category": "類別",
        "baseUrl": "基礎 URL",
        "launchMethod": "啟動方式",
        "paramMappings": "參數對應",
        "enableJwt": "啟用 JWT 權杖簽署",
        "sharedSecret": "共用密鑰（JWT 簽署金鑰）",
        "enableHmac": "啟用 URL 簽署（HMAC）",
        "hmacKey": "HMAC 金鑰",
        "requiredPermission": "所需權限",
        "displayOrder": "顯示順序",
        "showInChart": "在圖表中顯示",
        "showInSidebar": "在側邊欄中顯示"
      },
      "placeholder": {
        "appCode": "例如 pacs_viewer",
        "appName": "例如 PACS Viewer",
        "baseUrl": "https://pacs.hospital.com/viewer",
        "paramName": "URL 參數名稱",
        "unchanged": "（維持不變）",
        "sharedSecret": "輸入共用密鑰",
        "hmacKey": "輸入 HMAC 金鑰",
        "requiredPermission": "例如 RESULT_VIEW（留空 = 任何使用者）"
      },
      "addParameter": "新增參數",
      "cancel": "取消",
      "submitUpdate": "更新應用程式",
      "submitCreate": "建立應用程式"
    },
    "paramSource": {
      "patientMrn": "病患 MRN",
      "patientName": "病患姓名",
      "patientDob": "病患 DOB",
      "encounterId": "就診 ID",
      "encounterNumber": "就診編號",
      "orderNumber": "醫囑編號",
      "userName": "目前使用者姓名",
      "userId": "目前使用者 ID",
      "timestamp": "目前時間戳記"
    },
    "launch": "啟動 {{name}}"
  },
  "integrationForm": {
    "titleEdit": "編輯整合",
    "titleAdd": "新增整合",
    "subtitle": "由 VynaHL7 支援的 MLLP 與 HL7-over-HTTP 介面。憑證材料儲存在整合記錄上；輪替將在下次重新啟動伺服器或用戶端時生效。",
    "back": "返回",
    "cancel": "取消",
    "saveChanges": "儲存變更",
    "addIntegration": "新增整合",
    "storedBlank": "已儲存 — 留空以保留",
    "selectSibling": "— 選擇一個同層整合 —",
    "section": {
      "basics": "基本資訊",
      "connection": "連線",
      "tls": "TLS / mTLS",
      "auth": "驗證",
      "ackDelivery": "確認與遞送",
      "outboundRouting": "出站路由",
      "inboundTrust": "入站信任"
    },
    "fields": {
      "name": "名稱",
      "type": "類型",
      "direction": "方向",
      "description": "描述",
      "active": "啟用 — 取消勾選可軟停用此介面。",
      "host": "主機",
      "port": "連接埠",
      "enableTls": "啟用 TLS — 使用",
      "serverCert": "伺服器憑證（PEM）",
      "clientCert": "用戶端憑證（PEM）— mTLS 可選",
      "serverKey": "伺服器私密金鑰（PEM）",
      "clientKey": "用戶端私密金鑰（PEM）",
      "serverCa": "用戶端 CA 信任庫（PEM）— 用於 mTLS",
      "clientCa": "伺服器 CA 信任庫（PEM）— 可選，回退至系統根憑證",
      "method": "方法",
      "username": "使用者名稱",
      "password": "密碼",
      "bearerToken": "Bearer 權杖",
      "inboundAck": "入站 ACK 政策",
      "outboundAck": "出站 ACK 政策",
      "processingTimeout": "處理逾時（毫秒）",
      "pendingAckTtl": "待處理 ACK TTL（秒）",
      "networkRetry": "網路重試上限",
      "appNakRetry": "應用程式 NAK 重試上限",
      "reverseIntegration": "反向通道整合",
      "outboundTypes": "接收的訊息類型",
      "outboundEvents": "事件層級訂閱",
      "receivingApplication": "接收應用程式 (MSH-5)",
      "receivingFacility": "接收機構 (MSH-6)",
      "inboundTrustProfile": "此合作夥伴可以"
    },
    "placeholder": {
      "name": "Hospital LIS ADT",
      "description": "關於此介面的簡短說明 — 負責人、用途、訊息類型等。",
      "hostServer": "0.0.0.0",
      "hostClient": "lis.hospital.local",
      "portMllp": "2575",
      "portOther": "443",
      "username": "svc-vynaemr",
      "outboundEvents": "ADT^A01, SIU^S12",
      "receivingApplication": "LAB_A",
      "receivingFacility": "CENTRAL_LAB"
    },
    "helper": {
      "hostServer": "繫結位址。使用 0.0.0.0 可監聽所有介面。",
      "hostClient": "此用戶端應連線的遠端主機。",
      "tlsHandshake": "進行交握。",
      "authClientCert": "用戶端憑證/金鑰來自上方的 TLS 區段。",
      "authNone": "不附加 HTTP 驗證標頭。",
      "authRs7": "{{call}} 會將其接入每個出站要求。",
      "ackDefaults": "控制閘道如何 ACK 入站 HL7 訊息，以及如何解讀出站傳送的回應 ACK。預設值",
      "ackDefaultsTail": "與 0.19.0 之前的行為一致 — 可依合作方需要變更。",
      "processingTimeout": "同步應用程式 ACK 內聯處理的上限。逾時 → AE + 背景佇列重試。",
      "pendingAckTtl": "增強模式應用程式 ACK 等待時間，超過後由清掃器逾時處理。",
      "networkRetry": "佇列封鎖前的傳輸錯誤重試次數。",
      "appNakRetry": "AE/AR/CE/CR 的重試次數 — 通常為 2–3 次，因為相同負載很少在重試後成功。",
      "reverse": "增強模式透過指向合作方反向端點的同層整合遞送真正的應用程式 ACK。請先將同層建立為獨立的整合記錄，然後在此處連結。",
      "outboundRouting": "此夥伴接收的內容。未選取任何類型即表示此介面不是出站目的地，不會向其傳送任何訊息。",
      "outboundEvents": "選填，以逗號分隔。比整個訊息類型更精細 —— 適用於只需要特定事件的夥伴。",
      "receivingDefaults": "MSH-5 與 MSH-6 用於標示每則傳送到此處的訊息的接收方。留空則使用介面名稱。",
      "inboundTrust": "此合作夥伴可以對病人身分作出何種主張。驗證說明誰在連線；此設定說明允許他們告訴我們什麼。除非該對端確實是登錄主控系統，否則請保留部署預設值。"
    },
    "option": {
      "type": {
        "mllp": "MLLP（透過 TCP 的 HL7 v2）",
        "hoh": "HoH（透過 HTTPS 的 HL7）",
        "fhir": "FHIR R4"
      },
      "direction": {
        "client": "用戶端（出站）",
        "server": "伺服器（入站）"
      },
      "method": {
        "none": "無",
        "basic": "HTTP Basic",
        "bearer": "Bearer 權杖",
        "clientCert": "用戶端憑證（mTLS）"
      }
    },
    "ack": {
      "inbound": {
        "acceptOnly": "立即回傳 AA（目前預設）",
        "honorMsh16": "依訊息讀取 MSH-15/16",
        "forceSync": "內聯處理，依結果回傳 AA/AE/AR",
        "forceEnhanced": "立即回傳 CA + 透過反向通道回傳應用程式 ACK"
      },
      "outbound": {
        "fireAndForget": "傳送後不等待（目前預設）",
        "expectSync": "設定 MSH-16=AL，於 AE/AR 時重試",
        "expectEnhanced": "等待 CA + 後續的應用程式 ACK"
      }
    },
    "validation": {
      "nameRequired": "名稱為必填項目",
      "hostRequired": "主機為必填項目",
      "mllpPort": "MLLP 整合需要一個連接埠",
      "portNumber": "連接埠必須為數字",
      "tlsServerCertKey": "TLS 伺服器同時需要憑證與金鑰",
      "basicUsername": "Basic 驗證需要使用者名稱",
      "basicPassword": "Basic 驗證需要密碼",
      "bearerToken": "Bearer 驗證需要權杖",
      "enhancedReverse": "增強 ACK 模式需要一個反向整合 — 請在下方選擇。",
      "outboundEvent": "「{{value}}」不是本系統會傳送的訊息 —— 請使用 ADT 這類類型，或 ADT^A01 這類事件。"
    },
    "trust": {
      "useDeploymentDefault": "使用部署預設值",
      "observer": "觀察者 — 從不建立或變更病人",
      "demographics": "人口學資料 — 可更正我們已有的病人資料，包括死亡通知；從不建立",
      "registration": "登錄 — 亦可建立病人並合併病歷"
    },
    "__review_inboundTrust": "Machine-authored — needs native review"
  },
  "thirdPartyAppCategory": {
    "imaging": "影像",
    "laboratory": "檢驗",
    "pharmacy": "藥局",
    "specialty": "專科",
    "portal": "入口網站",
    "billing": "計費",
    "other": "其他"
  },
  "thirdPartyLaunchMethod": {
    "redirect": "重新導向",
    "popup": "彈出視窗",
    "iframe": "iframe",
    "newTab": "新分頁"
  },
  "cdsRule": {
    "form": {
      "titleEdit": "編輯 CDS 規則",
      "titleCreate": "建立 CDS 規則",
      "ruleName": "規則名稱",
      "ruleType": "規則類型",
      "selectPlaceholder": "請選擇…",
      "severity": "嚴重程度",
      "triggerEvent": "觸發事件",
      "actionType": "動作類型",
      "description": "描述",
      "active": "啟用",
      "cancel": "取消",
      "submitUpdate": "更新規則",
      "submitCreate": "建立規則",
      "createdOk": "規則建立成功",
      "createFailed": "建立規則失敗",
      "updatedOk": "規則更新成功",
      "updateFailed": "更新規則失敗",
      "validation": {
        "nameRequired": "規則名稱為必填欄位",
        "typeRequired": "規則類型為必填欄位",
        "descriptionRequired": "描述為必填欄位",
        "triggerRequired": "觸發事件為必填欄位",
        "actionRequired": "動作類型為必填欄位"
      }
    },
    "list": {
      "title": "CDS 規則",
      "subtitle": "管理臨床決策支援規則",
      "addRule": "新增規則",
      "loading": "正在載入 CDS 規則…",
      "loadError": "載入 CDS 規則失敗。",
      "empty": "尚未設定 CDS 規則。",
      "columns": {
        "ruleName": "規則名稱",
        "type": "類型",
        "severity": "嚴重程度",
        "description": "描述",
        "status": "狀態",
        "actions": "操作"
      },
      "toggleActive": "按一下以停用",
      "toggleInactive": "按一下以啟用",
      "active": "啟用",
      "inactive": "停用",
      "editRule": "編輯規則",
      "statusUpdated": "規則狀態已更新",
      "statusUpdateFailed": "更新規則狀態失敗"
    }
  },
  "cdsSeverity": {
    "info": "資訊",
    "warning": "警告",
    "critical": "嚴重"
  },
  "cdsTriggerEvent": {
    "orderSign": "醫囑簽署",
    "orderSelect": "醫囑選擇",
    "patientView": "檢視病人",
    "medicationPrescribe": "藥物開立",
    "resultReceived": "結果接收",
    "patientAdmit": "病人入院"
  },
  "cdsActionType": {
    "alert": "警示",
    "warning": "警告",
    "hardStop": "強制停止",
    "suggestion": "建議",
    "notification": "通知"
  },
  "cdsRuleType": {
    "drugInteraction": "藥物交互作用",
    "drugAllergy": "藥物過敏",
    "duplicateOrder": "重複醫囑",
    "custom": "自訂",
    "clinicalAlert": "臨床警示",
    "sepsisScreen": "敗血症篩檢"
  },
  "system": {
    "title": "系統設定",
    "subtitle": "應用程式設定、安全與系統運行狀況",
    "restartServices": "重新啟動服務",
    "restartToast": "重新啟動服務（佔位 - 需要確認）",
    "loadError": "載入系統設定失敗",
    "section": {
      "systemInfo": "系統資訊",
      "systemInfoDesc": "版本、運行時間與服務運行狀況",
      "general": "一般設定",
      "generalDesc": "應用程式名稱、時區與品牌",
      "security": "安全設定",
      "securityDesc": "密碼原則、MFA 與工作階段管理",
      "notifications": "通知設定",
      "notificationsDesc": "電子郵件與簡訊閘道設定",
      "integration": "整合預設值",
      "integrationDesc": "MLLP、FHIR 與 HL7 預設設定",
      "featureFlags": "功能旗標",
      "featureFlagsDesc": "啟用或停用系統功能",
      "patientAccess": "Patient Access",
      "patientAccessDesc": "Default patient visibility scope"
    },
    "info": {
      "version": "版本",
      "uptime": "運行時間",
      "database": "資料庫",
      "redis": "Redis",
      "microservices": "微服務",
      "conn": "連線"
    },
    "uptime": {
      "running": "執行中",
      "unknown": "未知",
      "up": "執行中"
    },
    "subsection": {
      "passwordPolicy": "密碼原則",
      "mfa": "多重要素驗證",
      "sessionLockout": "工作階段與鎖定",
      "emailConfig": "電子郵件設定",
      "smsGateway": "簡訊閘道",
      "mllpDefaults": "MLLP 預設值",
      "fhirConfig": "FHIR 設定",
      "hl7Encoding": "HL7 v2 編碼"
    },
    "fields": {
      "appName": "應用程式名稱",
      "timezone": "時區",
      "dateFormat": "日期格式",
      "supportEmail": "支援電子郵件",
      "logoUrl": "標誌 URL",
      "maintenanceMode": "維護模式（停用使用者存取）",
      "upload": "上傳",
      "minPasswordLength": "最小密碼長度",
      "passwordExpiry": "密碼有效期（天）",
      "requireUppercase": "需要大寫字母",
      "requireNumbers": "需要數字",
      "requireSpecialChars": "需要特殊字元",
      "enableMfa": "啟用 MFA",
      "mfaMethod": "MFA 方式",
      "sessionTimeout": "工作階段逾時（分鐘）",
      "maxLoginAttempts": "最大登入嘗試次數",
      "lockoutDuration": "鎖定時長（分鐘）",
      "smtpHost": "SMTP 主機",
      "smtpPort": "SMTP 連接埠",
      "smtpUser": "SMTP 使用者",
      "fromEmail": "寄件者電子郵件",
      "useTls": "使用 TLS",
      "enabled": "已啟用",
      "provider": "服務供應商",
      "fromNumber": "寄件號碼",
      "defaultPort": "預設連接埠",
      "timeoutSeconds": "逾時（秒）",
      "retryCount": "重試次數",
      "fhirBaseUrl": "FHIR 基礎 URL",
      "authMethod": "驗證方式",
      "fieldSeparator": "欄位分隔符",
      "encodingChars": "編碼字元",
      "visibilityScope": "Visibility scope",
      "visibilityScopeDesc": "Who can see a patient by default. Facilities may override this; the stricter side always wins. Takes effect immediately."
    },
    "option": {
      "tz": {
        "singapore": "亞洲/新加坡（UTC+8）",
        "hongKong": "亞洲/香港（UTC+8）",
        "kualaLumpur": "亞洲/吉隆坡（UTC+8）",
        "bangkok": "亞洲/曼谷（UTC+7）",
        "tokyo": "亞洲/東京（UTC+9）",
        "kolkata": "亞洲/加爾各答（UTC+5:30）",
        "sydney": "澳洲/雪梨（UTC+11）"
      },
      "mfa": {
        "totp": "TOTP（驗證器應用程式）",
        "sms": "SMS",
        "email": "電子郵件"
      },
      "fhirAuth": {
        "none": "無",
        "oauth2": "OAuth 2.0",
        "basic": "Basic Auth"
      },
      "visibility": {
        "organization": "Organization - shared health system",
        "facility": "Facility - shared facility (default)",
        "department": "Department - shared encounter department"
      }
    },
    "save": {
      "general": "儲存一般設定",
      "security": "儲存安全設定",
      "notifications": "儲存通知設定",
      "integration": "儲存整合設定",
      "features": "儲存功能旗標",
      "patientaccess": "Save Patient Access"
    },
    "sectionName": {
      "general": "一般",
      "security": "安全",
      "notifications": "通知",
      "integration": "整合",
      "features": "功能旗標",
      "patientaccess": "Patient Access"
    },
    "toast": {
      "uploadPlaceholder": "上傳標誌（佔位）",
      "saved": "{{section}}設定已成功儲存",
      "saveFailed": "儲存設定失敗"
    },
    "featureFlag": {
      "patientMerge": {
        "label": "病人合併",
        "description": "啟用病人合併/取消合併功能"
      },
      "breakGlass": {
        "label": "緊急存取",
        "description": "允許對受限記錄進行緊急覆寫"
      },
      "fhirApi": {
        "label": "FHIR R4 API",
        "description": "為外部系統公開 FHIR R4 端點"
      },
      "smartApps": {
        "label": "SMART on FHIR 應用程式",
        "description": "允許第三方 SMART 應用程式連線"
      },
      "clinicalDecisionSupport": {
        "label": "臨床決策支援",
        "description": "為醫囑輸入啟用 CDS 掛鉤"
      },
      "telemedicine": {
        "label": "遠距醫療模組",
        "description": "視訊會診與遠端監測"
      },
      "patientPortal": {
        "label": "病人入口網站",
        "description": "面向病人的記錄與預約入口"
      },
      "analyticsDashboard": {
        "label": "分析儀表板",
        "description": "進階分析與報表儀表板"
      },
      "medicationBarcode": {
        "label": "藥物條碼掃描",
        "description": "用藥給藥的條碼驗證"
      },
      "autoCoding": {
        "label": "自動編碼（ICD/CPT）",
        "description": "AI 輔助的診斷與處置編碼"
      }
    }
  },
  "audit": {
    "title": "稽核日誌",
    "subtitle": "系統活動日誌，包含詳細的變更追蹤",
    "exportCsv": "匯出 CSV",
    "exportToast": "正在將 {{count}} 筆稽核紀錄匯出為 CSV（佔位）",
    "searchPlaceholder": "依使用者搜尋…",
    "advanced": "進階",
    "breakGlassOnly": "僅緊急存取",
    "fromTo": "起始 / 結束：",
    "fromDate": "起始日期",
    "toDate": "結束日期",
    "clearFilters": "清除所有篩選條件",
    "entriesFound": "找到 {{count}} 筆紀錄",
    "noMatch": "沒有符合篩選條件的稽核紀錄",
    "viewDetails": "檢視詳情",
    "detail": {
      "title": "稽核紀錄詳情",
      "timestamp": "時間戳記",
      "user": "使用者",
      "action": "操作",
      "resource": "資源",
      "ipAddress": "IP 位址",
      "breakGlass": "緊急存取",
      "yes": "是",
      "no": "否",
      "details": "詳情",
      "dataChanges": "資料變更",
      "before": "變更前",
      "after": "變更後",
      "result": "結果"
    },
    "columns": {
      "timestamp": "時間戳記",
      "user": "使用者",
      "action": "操作",
      "resource": "資源",
      "resourceId": "資源 ID",
      "ipAddress": "IP 位址",
      "details": "詳情",
      "view": "檢視"
    },
    "filter": {
      "action": {
        "all": "所有操作",
        "create": "建立",
        "read": "讀取",
        "update": "更新",
        "delete": "刪除",
        "login": "登入",
        "logout": "登出",
        "export": "匯出",
        "breakGlass": "緊急存取"
      },
      "resource": {
        "all": "所有資源",
        "patient": "病人",
        "encounter": "就診",
        "order": "醫囑",
        "result": "結果",
        "medication": "用藥",
        "user": "使用者",
        "system": "系統"
      }
    },
    "pagination": {
      "first": "首頁",
      "last": "末頁",
      "pageOf": "第 {{page}} 頁，共 {{pages}} 頁",
      "range": "{{from}}-{{to}}，共 {{total}}"
    }
  },
  "taxonomy": {
    "title": "臨床分類體系",
    "subtitle": "服務線將相關臨床服務分組(Cardiovascular → Cardiology、EP Lab、Heart Failure Clinic)。兩者皆納入排程使用的服務 ↔ 地點指派矩陣。",
    "addServiceLine": "新增服務線",
    "addClinicalService": "新增臨床服務",
    "tabs": {
      "serviceLines": "服務線",
      "clinicalServices": "臨床服務"
    },
    "searchLines": "搜尋服務線...",
    "searchServices": "搜尋臨床服務...",
    "empty": {
      "linesNone": "尚未設定服務線。",
      "linesNoMatch": "沒有符合的服務線。",
      "servicesNone": "尚未設定臨床服務。",
      "servicesNoMatch": "沒有符合的臨床服務。"
    },
    "columns": {
      "name": "名稱",
      "code": "代碼",
      "description": "說明",
      "services": "服務數",
      "status": "狀態",
      "serviceLine": "服務線",
      "specialty": "專科",
      "actions": "操作"
    },
    "status": {
      "active": "啟用",
      "inactive": "停用"
    },
    "editTitle": "編輯"
  },
  "systemStatus": {
    "connected": "已連線",
    "error": "錯誤"
  },
  "escalation": {
    "title": "Escalation Rules",
    "subtitle": "Configure how an unacknowledged critical result is re-paged",
    "help": "An escalation rule is the re-paging ladder for a trigger event. A level fires when the ORIGINAL page is older than its delay (in minutes) and the result is still unacknowledged; every user holding the listed roles at the encounter's facility is then paged. Only the critical_result trigger is wired to a consumer today, so rules can be edited but not created.",
    "loadError": "Failed to load escalation rules.",
    "empty": "No escalation rules configured.",
    "active": "Active",
    "inactive": "Inactive",
    "selectPrompt": "Select a rule to edit its ladder.",
    "list": {
      "header": "Rules",
      "levelCount": "{{n}} levels"
    },
    "editor": {
      "ruleName": "Rule Name",
      "triggerEvent": "Trigger Event",
      "initialRecipient": "Initial page goes to: {{role}}",
      "active": "Active",
      "ladder": "Escalation Ladder",
      "level": "Level",
      "delayMinutes": "Delay (minutes)",
      "roles": "Roles Paged",
      "addRole": "Add a role...",
      "noRoles": "No roles selected — this level will be rejected.",
      "noLevels": "This rule has no levels. Add at least one.",
      "addLevel": "Add Level",
      "removeLevel": "Remove level {{level}}",
      "removeRole": "Remove role {{role}}",
      "reset": "Reset",
      "save": "Save Rule",
      "holderCount": "已配置 {{count}} 人",
      "unstaffedBadge": "無人員",
      "unstaffedWarning": "以下角色沒有任何人員，相應層級將無法呼叫任何人：{{roles}}。請在「管理 → 使用者」中為該角色指派人員。"
    },
    "validation": {
      "nameRequired": "Rule name is required.",
      "ladderRequired": "The ladder must have at least one level.",
      "levelInvalid": "Every level number must be 1 or greater.",
      "levelDuplicate": "Level numbers must be unique.",
      "delayInvalid": "Level {{level}}: the delay must be a whole number of minutes, 0 or greater.",
      "rolesRequired": "Level {{level}}: select at least one role.",
      "unknownRole": "Unknown role: {{role}}."
    },
    "toast": {
      "saved": "Escalation rule saved",
      "saveFailed": "Failed to save escalation rule",
      "invalidLadder": "The escalation ladder was rejected: check the level numbers, delays and roles.",
      "notFound": "Escalation rule not found",
      "forbidden": "You do not have permission to edit escalation rules"
    }
  },
  "review": {
    "list": {
      "title": "Access Reviews",
      "empty": "No review campaigns yet. Open one to snapshot every live grant for certification.",
      "columns": {
        "name": "Campaign",
        "status": "Status",
        "dueDate": "Due",
        "progress": "Progress",
        "created": "Opened",
        "actions": "Actions"
      },
      "status": {
        "open": "Open",
        "closed": "Closed"
      },
      "progress": "{{pending}} of {{total}} pending",
      "create": {
        "namePlaceholder": "Campaign name (blank = dated default)",
        "dueLabel": "Due",
        "submit": "Open campaign"
      }
    },
    "detail": {
      "back": "All reviews",
      "columns": {
        "user": "User",
        "role": "Role",
        "facility": "Facility",
        "window": "Grant window",
        "grantedBy": "Granted by",
        "state": "Grant",
        "decision": "Decision",
        "decidedBy": "Decided by",
        "actions": "Actions"
      },
      "certify": "Certify",
      "revoke": "Revoke",
      "live": "live",
      "dead": "lapsed",
      "permanent": "permanent",
      "allFacilities": "All facilities",
      "close": "Close campaign",
      "delete": "Delete",
      "filter": {
        "label": "Show",
        "all": "All",
        "pending": "Pending",
        "decided": "Decided"
      },
      "decision": {
        "pending": "Pending",
        "certified": "Certified",
        "revoked": "Revoked"
      },
      "closeBlocked": "{{count}} item(s) still pending",
      "empty": "No grants were live when this campaign opened.",
      "confirmRevoke": {
        "title": "Revoke this grant?",
        "description": "The role grant is deleted for real — the user loses it immediately. This cannot be undone from the review.",
        "confirm": "Revoke grant"
      },
      "confirmClose": {
        "title": "Close this campaign?",
        "description": "Closed campaigns are the attestation record: items can no longer be decided and the campaign cannot be deleted.",
        "confirm": "Close campaign"
      },
      "confirmDelete": {
        "title": "Delete this campaign?",
        "description": "The open campaign and its undecided items are discarded. Only open campaigns can be deleted.",
        "confirm": "Delete campaign"
      }
    },
    "toast": {
      "created": "Review campaign opened",
      "createError": "Failed to open review campaign",
      "certified": "Grant certified",
      "revoked": "Grant revoked",
      "closed": "Review campaign closed",
      "deleted": "Review campaign deleted",
      "saveError": "Failed to save the decision"
    }
  },
  "sso": {
    "title": "Single sign-on",
    "subtitle": "Identity providers, email domains, and LDAP directories",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "tabs": {
      "providers": "Providers",
      "directories": "Directories",
      "domains": "Domains",
      "scim": "SCIM provisioning"
    },
    "providers": {
      "new": "New provider",
      "edit": "Edit provider",
      "delete": "Delete provider",
      "empty": "No identity providers yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "kind": "Kind",
        "issuer": "Issuer",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Provider deleted. {{count}} logins kept.",
        "deleted": "Provider deleted.",
        "deleteFailed": "Could not delete the provider."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked. In-flight sign-in states and group mappings go with the provider.",
        "confirm": "Delete"
      }
    },
    "directories": {
      "new": "New directory",
      "edit": "Edit directory",
      "delete": "Delete directory",
      "empty": "No LDAP directories yet.",
      "columns": {
        "name": "Name",
        "system": "Health system",
        "host": "Host",
        "tls": "TLS",
        "status": "Status",
        "users": "Users",
        "actions": "Actions"
      },
      "toast": {
        "deletedKept": "Directory deleted. {{count}} logins kept.",
        "deleted": "Directory deleted.",
        "deleteFailed": "Could not delete the directory."
      },
      "deleteConfirm": {
        "title": "Delete {{name}}?",
        "description": "Provisioned logins survive ({{count}}), unlinked, with their current roles. Directory-bound mappings go with the directory.",
        "confirm": "Delete"
      }
    },
    "domains": {
      "new": "Claim domain",
      "delete": "Release domain",
      "empty": "No email domains claimed yet.",
      "columns": {
        "domain": "Domain",
        "system": "Health system",
        "actions": "Actions"
      },
      "toast": {
        "created": "{{domain}} claimed.",
        "createFailed": "Could not claim the domain.",
        "deleted": "Domain released.",
        "deleteFailed": "Could not release the domain."
      },
      "deleteConfirm": {
        "title": "Release {{domain}}?",
        "description": "Staff with this email domain will no longer route to SSO.",
        "confirm": "Release"
      },
      "add": {
        "title": "Claim email domain",
        "description": "One domain routes to exactly one health system.",
        "confirm": "Claim",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "domain": "Domain"
      }
    },
    "scim": {
      "hint": "Point the identity provider's SCIM client at {{url}} \u2014 one bearer token per health system, pasted as the secret.",
      "copyUrl": "Copy URL",
      "urlCopied": "Tenant URL copied.",
      "new": "New token",
      "empty": "No SCIM tokens yet.",
      "columns": {
        "label": "Label",
        "system": "Health system",
        "prefix": "Prefix",
        "status": "Status",
        "actions": "Actions"
      },
      "revoke": "Revoke token",
      "toast": {
        "mintFailed": "Could not mint the token.",
        "revoked": "Token revoked.",
        "revokeFailed": "Could not revoke the token."
      },
      "revokeConfirm": {
        "title": "Revoke {{label}}?",
        "description": "The token stops authenticating immediately. In-flight sync cycles fail on their next call.",
        "confirm": "Revoke"
      },
      "mint": {
        "title": "Mint SCIM token",
        "description": "One token provisions exactly one health system. The secret renders once.",
        "confirm": "Mint",
        "system": "Health system",
        "systemPlaceholder": "Select a health system",
        "label": "Label"
      },
      "secret": {
        "title": "Token minted",
        "body": "Copy this secret into the identity provider now \u2014 it never renders again.",
        "secret": "Secret",
        "copy": "Copy secret",
        "copied": "Secret copied.",
        "dismiss": "Done"
      }
    },
    "providerForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit identity provider",
      "newTitle": "New identity provider",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "kind": "Protocol",
      "kindOidc": "OpenID Connect (OIDC)",
      "kindSaml": "SAML 2.0",
      "kindFlipHint": "Changing protocol clears the other protocol's settings on save.",
      "issuer": "Issuer URL",
      "issuerSamlHint": "The IdP entity ID — must exactly match the entity in the metadata below. URNs (e.g. ADFS) are fine.",
      "clientId": "Client ID",
      "clientSecret": "Client secret",
      "secretKeep": "A secret is stored. Leave blank to keep it.",
      "secretUnset": "No secret stored (public client).",
      "secretNewHint": "Blank means no secret (public client).",
      "secretClear": "Clear the stored secret",
      "groupClaim": "Group claim",
      "metadata": "IdP metadata XML",
      "metadataHint": "Paste the IdP metadata XML. It must parse and name the entity ID above.",
      "save": "Save",
      "saving": "Saving…",
      "test": "Test connection",
      "testing": "Testing…",
      "toast": {
        "updated": "Provider updated.",
        "created": "Provider created.",
        "failed": "Could not save the provider.",
        "testFailed": "Could not test the provider."
      }
    },
    "maps": {
      "title": "Group mappings",
      "subtitle": "IdP groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this IdP group receive the role at sign-in.",
        "confirm": "Add",
        "group": "IdP group",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    },
    "directoryForm": {
      "back": "Back to single sign-on",
      "editTitle": "Edit LDAP directory",
      "newTitle": "New LDAP directory",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "enabled": "Enabled",
      "host": "Host",
      "port": "Port",
      "portPlaceholder": "Default",
      "tlsMode": "TLS mode",
      "tlsVerify": "Verify TLS certificates",
      "caPem": "CA bundle (PEM)",
      "caSet": "A CA bundle is stored.",
      "caReplace": "Replace",
      "caEditHint": "Blank clears to system roots. Leave the toggle off to keep the stored bundle.",
      "caNewHint": "Blank means system roots. Paste the hospital root CA for private PKI.",
      "bindDn": "Bind DN",
      "bindPassword": "Bind password",
      "passwordKeep": "A password is stored. Leave blank to keep it.",
      "passwordUnset": "No password stored (anonymous search).",
      "passwordNewHint": "Blank with a bind DN refuses; blank without one means anonymous search.",
      "passwordClear": "Clear the stored password",
      "baseDn": "Base DN",
      "userFilter": "User filter",
      "groupAttribute": "Group attribute",
      "nameAttribute": "Name attribute",
      "save": "Save",
      "saving": "Saving…",
      "toast": {
        "updated": "Directory updated.",
        "created": "Directory created.",
        "failed": "Could not save the directory."
      }
    },
    "ldapMaps": {
      "title": "Group mappings",
      "subtitle": "Directory groups granted a role at next sign-in.",
      "new": "Add mapping",
      "empty": "No group mappings yet.",
      "columns": {
        "group": "Group",
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "systemWide": "All facilities",
      "delete": "Delete mapping",
      "toast": {
        "created": "Mapping added.",
        "createFailed": "Could not add the mapping.",
        "deleted": "Mapping deleted.",
        "deleteFailed": "Could not delete the mapping."
      },
      "add": {
        "title": "Add group mapping",
        "description": "Members of this directory group receive the role at sign-in.",
        "confirm": "Add",
        "group": "Directory group (CN)",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (blank means all facilities)"
      },
      "deleteConfirm": {
        "title": "Delete mapping for {{group}}?",
        "description": "Existing grants stay until the next sign-in re-derives them.",
        "confirm": "Delete"
      }
    }
  }
,
  "userGroups": {
    "title": "User Groups",
    "subtitle": "Health-system groups with materialized role grants.",
    "new": "New group",
    "edit": "Edit",
    "delete": "Delete",
    "empty": "No user groups yet.",
    "status": {
      "active": "Active",
      "inactive": "Inactive"
    },
    "columns": {
      "name": "Name",
      "system": "Health system",
      "status": "Status",
      "members": "Members",
      "grants": "Grants",
      "actions": "Actions"
    },
    "toast": {
      "deleted": "Group deleted.",
      "deletedRetracted": "Group deleted; {{count}} grant(s) retracted.",
      "deleteFailed": "Could not delete the group."
    },
    "confirmDelete": {
      "title": "Delete this group?",
      "description": "Memberships and grants go with {{name}}. Grants no other group covers retract immediately."
    },
    "form": {
      "back": "Back to groups",
      "newTitle": "New user group",
      "editTitle": "Edit user group",
      "healthSystem": "Health system",
      "healthSystemPlaceholder": "Select a health system",
      "name": "Name",
      "namePlaceholder": "e.g. Night-shift nurses",
      "active": "Active",
      "activeHint": "Deactivating retracts every grant this group confers until reactivated.",
      "save": "Save",
      "saving": "Saving\u2026",
      "cancel": "Cancel",
      "toast": {
        "created": "Group created.",
        "createFailed": "Could not create the group.",
        "saved": "Group saved.",
        "saveFailed": "Could not save the group.",
        "loadFailed": "Could not load the group."
      }
    },
    "members": {
      "title": "Members",
      "subtitle": "The group\u2019s grants apply to every member.",
      "add": "Add member",
      "remove": "Remove",
      "empty": "No members yet.",
      "columns": {
        "username": "Username",
        "fullName": "Full name",
        "actions": "Actions"
      },
      "toast": {
        "added": "Member added.",
        "addFailed": "Could not add the member.",
        "removed": "Member removed.",
        "removeFailed": "Could not remove the member."
      },
      "addDialog": {
        "title": "Add member",
        "description": "The group\u2019s grants apply to the new member immediately.",
        "confirm": "Add",
        "user": "User",
        "userPlaceholder": "Select a user"
      },
      "deleteConfirm": {
        "title": "Remove {{name}}?",
        "description": "Grants no other group covers retract immediately."
      }
    },
    "grants": {
      "title": "Grants",
      "subtitle": "Roles this group confers on its members.",
      "add": "Add grant",
      "remove": "Remove",
      "empty": "No grants yet.",
      "systemWide": "System-wide",
      "columns": {
        "role": "Role",
        "facility": "Facility",
        "actions": "Actions"
      },
      "toast": {
        "added": "Grant added.",
        "addFailed": "Could not add the grant.",
        "removed": "Grant removed.",
        "removeFailed": "Could not remove the grant."
      },
      "addDialog": {
        "title": "Add grant",
        "description": "The grant fans out to every member immediately.",
        "confirm": "Add",
        "role": "Role",
        "rolePlaceholder": "Select a role",
        "facility": "Facility (optional)"
      },
      "deleteConfirm": {
        "title": "Remove the {{role}} grant?",
        "description": "Members lose it unless another grant still covers them."
      }
    }
  },
  "fileKey": {
      "title": "License key",
      "subtitle": "File-key licensing for this self-managed installation.",
      "refresh": "Refresh",
      "loadError": "Could not load license status.",
      "status": {
        "valid": "Valid",
        "evaluation": "Evaluation",
        "grace": "Grace period",
        "expired": "Expired",
        "invalid": "Invalid",
        "serving": "Serving requests.",
        "refused": "Refusing requests.",
        "reason": "Reason",
        "evalCountdown": "No license key installed. Evaluation ends in {{count}} days — install a key before then.",
        "evalCapUsage": "Evaluation patients: {{used}} of {{cap}} used. New registrations refuse past the cap \u2014 install a license key to continue.",
        "graceCountdown": "Service continues for {{count}} more hours while this is resolved. Install a valid key before the window closes."
      },
      "fields": {
        "customer": "Customer",
        "format": "Format",
        "purpose": "Purpose",
        "expires": "Expires",
        "maxUsers": "Max users",
        "derivation": "Host binding",
        "features": "Features"
      },
      "format": {
        "flostel": "FLOSTEL (JSON)",
        "vyna": "Legacy VYNA"
      },
      "derivation": {
        "strong": "Strong (hardware-anchored)",
        "weak": "Weak (machine-id only)"
      },
      "hosts": {
        "title": "Bound hosts",
        "subtitle": "Every host computer ID this key covers. HA installs carry one entry per host.",
        "floating": "Floating key — not bound to any host.",
        "covered": "Key covers {{count}} host(s).",
        "thisHost": "This host",
        "notCovered": "This host is NOT covered by the installed key. The key was issued for different host IDs."
      },
      "host": {
        "title": "This host",
        "subtitle": "Send this computer ID to the vendor to receive a bound key. HA installs collect one per host.",
        "copy": "Copy",
        "copied": "Copied",
        "copyFailed": "Copy failed.",
        "strength": "Binding strength",
        "dmi": "DMI product UUID",
        "present": "Present",
        "absent": "Unreadable",
        "machineId": "OS machine ID",
        "why": "Why two IDs?"
      },
      "request": {
        "title": "Request a key",
        "subtitle": "Generate the unsigned request file the vendor signs. This host is always included; add HA members below. Contact and notes go in the email summary only.",
        "customerLabel": "Customer",
        "customerPlaceholder": "e.g. Acme Hospital",
        "maxUsersLabel": "Max users",
        "maxUsersPlaceholder": "Blank = unlimited",
        "contactLabel": "Contact",
        "contactPlaceholder": "Name and email for the vendor",
        "notesLabel": "Notes",
        "notesPlaceholder": "Optional context for the vendor",
        "featuresLabel": "Licensed modules",
        "hostsLabel": "Extra HA hosts",
        "hostsPlaceholder": "One host fingerprint per line, from each member's license page",
        "hostsHint": "This host ({{fp}}) is always included.",
        "generate": "Generate request",
        "invalidMaxUsers": "Max users must be a whole number.",
        "failed": "Request generation failed.",
        "summaryTitle": "Email summary",
        "copySummary": "Copy summary",
        "copiedSummary": "Copied",
        "fileTitle": "Request file",
        "download": "Download request file"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "License key installed.",
        "failed": "Key install failed.",
        "haNote": "HA: repeat on every host, or mount one key file everywhere. Kubernetes Secret mounts are updated in the cluster, not here."
      }
    },
    "orgKey": {
      "title": "Organization license key",
      "subtitle": "Signed module license for health system {{id}}.",
      "back": "Health systems",
      "refresh": "Refresh",
      "loadError": "Could not load organization key status.",
      "status": {
        "valid": "Valid",
        "missing": "Not installed",
        "broken": "Invalid",
        "missingHint": "No key installed. Premium modules (billing, analytics) stay off; clinical care is unaffected.",
        "reason": "Reason"
      },
      "fields": {
        "customer": "Customer",
        "expires": "Expires",
        "maxUsers": "Max users",
        "purpose": "Purpose",
        "installedAt": "Installed",
        "features": "Licensed modules"
      },
      "install": {
        "title": "Install a key",
        "subtitle": "Paste the JSON key from the vendor. It is verified before anything is written — invalid keys are refused, never stored.",
        "placeholder": "Paste the license key JSON here…",
        "action": "Install key",
        "success": "Organization key installed.",
        "failed": "Key install failed.",
        "floatingNote": "Organization keys must be floating — machine binding is meaningless for SaaS."
      },
      "delete": {
        "title": "Remove the key",
        "subtitle": "Premium modules turn off for every facility in this organization. Clinical care is unaffected.",
        "action": "Remove key",
        "confirm": "Yes, remove it",
        "cancel": "Cancel",
        "success": "Organization key removed.",
        "failed": "Key removal failed."
      }
    }
}
